// Imported rows keep the typeset CSV cell in range, with an empty value.
export function ratingText(row, ce = false) {
  if (!row.range) return row.value
  if (row.value) return `${row.range} nm ${row.value}`
  if (!ce || !/\bAB\s*\d/i.test(row.range)) return row.range
  const mark = '(?:[DIRM]+\\s*(?:LB|L|AB)\\s*\\d+Y?|RB\\s*\\d+)'
  const marks = `(${mark}(?:\\s*\\+?\\s*${mark})*)`
  const bound = '[<>≤≥]?=?\\s*\\d+(?:\\.\\d+)?'
  const range = `(${bound}(?:\\s*[-–—]\\s*${bound})?)`
  return row.range.replace(new RegExp(`${marks}\\s+${range}`, 'gi'), (_, marking, wavelength) => `${wavelength} ${marking}`)
}
